import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';

export class FilterFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    quickSearchPlaceholder: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        quickSearchPlaceholder?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.quickSearchPlaceholder = quickSearchPlaceholder;
    }
}
